<template>
    <div
      @mouseleave="onMouseLeaveGrid"
    >
      <div class="preview" :style="{'aspect-ratio': aspectRatio}">
        <MenuRenderPreview v-if="selectedMenuForGrid" :menu="selectedMenuForGrid"/>
        <div
          class="grid"
          :style="{ gridTemplateColumns: `repeat(${col}, 1fr)`, gridTemplateRows: `repeat(${row}, 1fr)`, padding: `${paddingGrid}px`}"
        >
          <div
            v-for="item in arrayMatrixByPosition"
            :key="`${item.col}-${item.row}`"
            :data-id="`${item.col}-${item.row}`"
            :class="`grid-box grid-box-selection ${!selectedGridItem ? 'grid-box-not-click' : ''}`"
            @pointerdown.prevent="selectedGridItem && onMouseDown(item)"
            @pointerup="selectedGridItem && onMouseLeave(item)"
            @mouseover="selectedGridItem && onMouseMove(item)"
          >
          </div>
        </div>
        <div
          :class="`grid gridchild ${this.clicked ? 'drag' : ''}`"
          :style="{ gridTemplateAreas: gridTemplateArea , padding: `${paddingGrid}px`}"
        >
          <div
            v-for="(item, index) in child"
            :key="`${item.col}-${item.row}-${index}`"
            :data-id="`${item.col}-${item.row}`"
            :style="{ gridArea: item.value }"
            class="grid-box grid-box-child"
          >
            <div class="item-name">{{ item.value }}</div>
            <button @click="removeChild(item.value)">&times;</button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Watch } from 'vue-property-decorator';
import MenuRenderPreview from './menuRenderPreview.vue';
import WindowsPortal from './windowsPortal.vue';

@Component
@Components({ MenuRenderPreview, WindowsPortal })
@MapActions(['selectGridTemplateArea', 'gridItemToDelete', 'updateMenuGridConfiguration'])
@MapGetters([
  'col',
  'row',
  'selectedGridItem',
  'gridTemplateArea',
  'selectedMenuForGrid',
  'gridConfiguration',
  'paddingGrid',
  'selectedGridItemToDelete',
  'aspectRatio'
])
export default class GridGenerator extends Vue {
  child = []

  arrayMatrix = []

  clicked = false;

  firstItemClicked = null;

  lastItemClicked = null;

  created() {
    this.initializeArrayMatrix();
  }

  get arrayMatrixByPosition() {
    const arrayByPosition = [];
    for (let i = 0; i < this.arrayMatrix.length; i++) {
      for (let j = 0; j < this.arrayMatrix[i].length; j++) {
        arrayByPosition.push({
          row: i,
          col: j,
          value: this.arrayMatrix[i][j]
        });
      }
    }
    return arrayByPosition;
  }

  gridTemplateAreaGenerator() {
    let gridTemplate = '';
    for (let i = 0; i < this.arrayMatrix.length; i++) {
      gridTemplate += '"';
      for (let j = 0; j < this.arrayMatrix[i].length; j++) {
        gridTemplate += `${this.arrayMatrix[i][j]} `;
      }
      gridTemplate += '"';
      gridTemplate += '\n';
    }
    return gridTemplate;
  }

  initializeArrayMatrix() {
    const col = Number(this.col);
    const row = Number(this.row);
    this.arrayMatrix = new Array(row);
    for (let i = 0; i < row; i++) {
      this.arrayMatrix[i] = new Array(col).fill('.');
    }
  }

  onMouseDown(item) {
    this.clicked = true;
    this.firstItemClicked = item;
    this.lastItemClicked = item;
    this.placeChild();
  }

  onMouseLeave() {
    this.firstItemClicked = null;
    this.lastItemClicked = null;
    this.clicked = false;
  }

  onMouseMove(item) {
    if (this.clicked) {
      this.lastItemClicked = item;
      this.placeChild();
    }
  }

  onClosePortal() {
    this.setOpenPortal(false);
  }

  onMouseLeaveGrid() {
    if (this.clicked) {
      this.clicked = false;
    }
  }

  clearSelectedClause(tempArray) {
    for (let i = 0; i < tempArray.length; i++) {
      for (let j = 0; j < tempArray[0].length; j++) {
        if (tempArray[i][j] === this.selectedGridItem.name) {
          tempArray[i][j] = '.';
        }
      }
    }
    const childTemp = this.child.filter((each) => each.value !== this.selectedGridItem.name);
    return { tempArray, childTemp };
  }

  placeChild() {
    const { tempArray, childTemp } = this.clearSelectedClause([...this.arrayMatrix]);
    const maxRow = Math.max(this.firstItemClicked.row, this.lastItemClicked.row);
    const maxCol = Math.max(this.firstItemClicked.col, this.lastItemClicked.col);
    const minRow = Math.min(this.firstItemClicked.row, this.lastItemClicked.row);
    const minCol = Math.min(this.firstItemClicked.col, this.lastItemClicked.col);

    if (maxRow === minRow && maxCol === minCol) {
      tempArray[maxRow][maxCol] = this.selectedGridItem.name;
    } else if (maxRow === minRow && maxCol !== minCol) {
      for (let j = minCol; j <= maxCol; j++) {
        tempArray[maxRow][j] = this.selectedGridItem.name;
      }
    } else if (maxCol === minCol && maxRow !== minRow) {
      for (let i = minRow; i <= maxRow; i++) {
        tempArray[i][maxCol] = this.selectedGridItem.name;
      }
    } else {
      for (let i = minRow; i <= maxRow; i++) {
        for (let j = minCol; j <= maxCol; j++) {
          tempArray[i][j] = this.selectedGridItem.name;
        }
      }
    }

    let filteredChildren = this.arrayMatrixByPosition.filter((arrayItem) => (arrayItem.col >= minCol && arrayItem.col <= maxCol) && (arrayItem.row >= minRow && arrayItem.row <= maxRow) && (arrayItem.value !== this.selectedGridItem.name));

    this.arrayMatrix = tempArray;

    filteredChildren = filteredChildren.map((each) => {
      each.value = this.selectedGridItem.name;
      return each;
    });
    this.child = [...childTemp, ...filteredChildren];
  }

  removeChild(value) {
    this.child = this.child.filter((item) => item.value !== value);
    const filteredChildWithSameValue = this.arrayMatrixByPosition.filter((each) => each.value === value);
    filteredChildWithSameValue.forEach((child) => this.changeArrayMatrixValue(child.row, child.col, '.'));
  }

  changeArrayMatrixValue(row, col, value) {
    this.arrayMatrix[row][col] = value;
    this.arrayMatrix = [...this.arrayMatrix];
  }

  @Watch('col', { immediate: true })
  onColChange(updateCol, previousCol) {
    if (previousCol !== updateCol) {
      this.initializeArrayMatrix();
      this.child = [];
    }
  }

  @Watch('row', { immediate: true })
  onRowChange(updateRow, previousRow) {
    if (updateRow !== previousRow) {
      this.initializeArrayMatrix();
      this.child = [];
    }
  }

  @Watch('arrayMatrix')
  onArrayMatrix(updatedArray, previousArray) {
    if (updatedArray !== previousArray) {
      const templateArea = this.gridTemplateAreaGenerator();
      this.selectGridTemplateArea(templateArea);
    }
  }

  @Watch('gridConfiguration', { immediate: true })
  onGridConfiguration(updated, previous) {
    if (updated !== previous) {
      if (updated.gridTemplateArea !== '') {
        this.child = [];
        const tempArrayMatrix = [...this.arrayMatrix];
        const splitJumpsLines = updated.gridTemplateArea.split(/\r?\n/);
        for (let i = 0; i < splitJumpsLines.length; i++) {
          const splitDoubleQuotationMarks = splitJumpsLines[i].split('"')[1];
          const splitEachItem = splitDoubleQuotationMarks.trim().split(' ');
          for (let j = 0; j < splitEachItem.length; j++) {
            const value = splitEachItem[j];
            tempArrayMatrix[i][j] = value;
            if (value !== '.') {
              this.child.push({
                row: i,
                col: j,
                value,
              });
            }
          }
        }
        this.$nextTick(() => {
          this.arrayMatrix = tempArrayMatrix;
        });
      }
    }
  }

  @Watch('selectedGridItemToDelete')
  onGridItemToDelete(updated) {
    if (updated) {
      this.removeChild(updated.name);
      this.gridItemToDelete(null);
      // this.updateMenuGridConfiguration();
    }
  }
}
</script>
<style scoped lang="scss">
.grid {
  width: 100%;
  height: 100%;
  position: absolute;
  display: grid;
  grid-auto-flow: row dense;
  top: 0
}

.preview {
  width: auto;
  height: 100%;
  position: absolute;
}

.grid-box {
    border: 2px dotted gold;
    transition: 0.2s all ease;
    cursor: crosshair;
    position: relative;
    z-index: 1000;
}

.grid-box-selection:hover {
  background: rgba(3, 44, 88, 0.5);
}

.grid-box-not-click {
  cursor: default;
}

.grid-box-not-click:hover {
  background: unset;
}

.grid-box-child {
  border: 2px solid #005bff;
}

.drag {
  z-index: 0;
}

.gridchild .grid-box{
  cursor: default;
}

.gridchild div button {
  position: absolute;
  right: 0;
  padding: 0 5px;
  margin: 0;
  color: #ffffff;
  background-color: red;
  border: none;
  z-index: 99999;
  top: 0px;
}

.child {
  background: red;
}

.item-name {
  position: absolute;
  background: rgba(0,91,255);
  color: #ffffff;
  display: block;
  padding: 0 5px;
  text-align: left;
}

</style>
